import { useEffect, useState } from "react"
import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import { Alert, Col, Row } from "reactstrap"
import { Link } from "react-router-dom"

import Application from "services/applications/Application.service"
const BASE_URL = process.env.REACT_APP_BASE_URL

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const OfficerForm = props => {
  const [officerSubmitted, setofficerSubmitted] = useState(false)
  const [showComments, setshowComments] = useState()
  const [comments, setcomments] = useState()
  const [showInspectionReportSection, setshowInspectionReportSection] =
    useState(false)
  const [manualProcessing, setmanualProcessing] = useState(false)
  const [inspectionDocument, setinspectionDocument] = useState()
  const [showCertificatePreview, setshowCertificatePreview] = useState(false)
  const [unsignedCertificate, setunsignedCertificate] = useState()
  

  const certPreviewUrl =
    BASE_URL + "verify/certificate/" + props.appDetails.app_id + "?preview=true"

  useEffect(() => {}, [])

  const decisionValueChange = value => {
    const commentsCodes = ["011", "012"]
    if (commentsCodes.includes(value)) {
      setshowComments(true)
    } else {
      setcomments("")
      setshowComments(false)
    }

    // Officer will upload inspection report if decision is not `return to applicant`
    if (value != "012") {
      setshowInspectionReportSection(true)
    } else {
      setshowInspectionReportSection(false)
    }

    // show certificate preview
    if (value == "010" && !manualProcessing) {
      setshowCertificatePreview(true)
    } else {
      setshowCertificatePreview(false)
    }
  }

  const changeInspectionDocument = e => {
    if (e.target.files.length > 0) {
      setinspectionDocument(e.target.files[0])
    }
  }

  async function uploadInspectionReport() {

    const report = {
      file: inspectionDocument,
      application_id: props.appDetails.id,
      description: "inspection_report",
    }

    const response = await appService.uploadFile(report)
  }

  async function uploadUnsignedCertificate() {
    const report = {
      file: unsignedCertificate,
      application_id: props.appDetails.id,
      description: "manual_certificate",
    }
    const response = await appService.uploadFile(report)
  }

  const changeManualCertificate = e => {
    if (e.target.files.length > 0) {
      setunsignedCertificate(e.target.files[0])
    }
  }

  const handleProcessingType = value => {
    if (value != "yes") {
      // not manual processing
      setmanualProcessing(false)
      return
    } else {
      setmanualProcessing(true)
    }
  }

  const submitDocuments = () => {
    uploadInspectionReport()
    uploadUnsignedCertificate()
  }

  return (
    <>
      <div>
        <AvField
          type="hidden"
          name="application_id"
          value={props.appDetails.id}
        />
      </div>

      <div>
        {props.error && props.error == true ? (
          <Row className="alert alert-danger">
            <Col md="12">{props.message}</Col>
          </Row>
        ) : null}

        {props.success && props.success == true ? (
          <Row className="alert alert-success">
            <Col md="8">{props.message}</Col>
            <Col md="4">
              <Link to="/dashboard" style={{ float: "right" }}>
                Back
              </Link>
            </Col>
          </Row>
        ) : null}
      </div>

      {manualProcessing ? (
        <Alert color="warning">
          Please take note that you have chosen that this application be
          processed manually. Applications marked as <b>Processed manually</b>{" "}
          will require that reviewers upload an unsigned authorization certificate.
        </Alert>
      ) : null}

      <div className="mb-3">
        <label>Will the application be archived?</label>
        <AvRadioGroup
          inline
          name="manually_processed"
          label=""
          onChange={e => handleProcessingType(e.target.value)}
          required
        >
          <AvRadio label="Yes" value="yes" />
          <AvRadio label="No" value="no" />
        </AvRadioGroup>
      </div>

      <div className="mb-3">
        <AvField
          disabled={props.success}
          type="select"
          name="decision_code"
          label="Select Decision"
          //value={defaultValues.decision_code}
          required
          onChange={v => {
            decisionValueChange(v.target.value)
          }}
        >
          <option value="">--select Decision--</option>
          <option value="010">Propose to Approve</option>

          <option value="011">Propose to Reject</option>
          <option value="012">Return to Applicant</option>
        </AvField>
      </div>

      <Row className="mb-3">
        <label htmlFor="reason" className="col-lg-3 col-form-label">
          Reason
        </label>
        <div className="col-lg-9">
          <AvField
            disabled={props.success}
            type="textarea"
            // value={defaultValues.reason}
            id="reason"
            name="reason"
            rows="2"
            required
            className="form-control"
          ></AvField>
        </div>
      </Row>

      {showInspectionReportSection ? (
        <Row className="mb-3">
          <label>Upload Inspection Report</label>
          <input
            className="form form-control"
            type="file"
            name="inspection_report"
            accept=".pdf,image/*,.doc,.docx"
            onChange={changeInspectionDocument}
            required
          />
        </Row>
      ) : null}

      {manualProcessing ? (
        <Row className="mb-3">
          <label>Upload Unsigned Certificate</label>
          <input
            className="form form-control"
            type="file"
            name="manual_certificate"
            accept=".pdf,image/*,.doc,.docx"
            onChange={changeManualCertificate}
            required
          />
        </Row>
      ) : null}

      {showCertificatePreview ? (
        <Row className="mb-3">
          <Alert color="info">
            Before submitting your review, please click on the preview link
            below to see how the certificate will display after the approval
            processes.
          </Alert>
          <a className="linkItem" target="_blank" href={certPreviewUrl}>
            Preview Certificate{" "}
            <i className="fa fa-certificate" title="Preview Certificate"></i>
          </a>
        </Row>
      ) : null}

      {showComments ? (
        <Row className="mb-3">
          <label
            htmlFor="comment_to_applicant"
            className="col-lg-3 col-form-label"
          >
            Comments to applicant
          </label>
          <div className="col-lg-9">
            <AvField
              disabled={props.success}
              type="textarea"
              id="comment_to_applicant"
              name="comment_to_applicant"
              //value={defaultValues.comment_to_applicant}
              rows="4"
              required
              className="form-control"
              onChange={v => {
                //setcomments(v.target.value)
              }}
            ></AvField>
          </div>
        </Row>
      ) : null}
      {props.loading && props.loading === true ? (
        <Link
          to="#"
          className="spinner-border text-info"
          style={{ float: "right" }}
        />
      ) : (
        <div className="mt-5">
          <button
            className="btn btn-lg btn-primary col-12"
            disabled={props.success}
            onClick={submitDocuments}
          >
            Submit Review
          </button>
        </div>
      )}
    </>
  )
}

export default OfficerForm
